<template>
  <div v-if="isOpen" class="popup-overlay">
    <div class="popup-header">
      <button type="button" class="close-btn" @click="onClose">
        <CloseIcon color="white" />
      </button>
    </div>

    <ul
      class="popup-content"
      :style="{
        color: tonal.gray[200],
      }"
    >
      <li
        v-for="(option, index) in options"
        :key="index"
        :class="{ selected: isSelected(option) }"
        :style="{ color: isSelected(option) && tonal.white.white }"
        @click="onSelect(option, index)"
      >
        {{ option.title }}
      </li>
    </ul>
  </div>
</template>

<script>
  import { tonal } from '@/constants/tonal'
  import { CloseIcon } from '@/components/Icons'

  export default {
    name: 'WPopup',

    components: {
      CloseIcon,
    },

    props: {
      isOpen: {
        type: Boolean,
        default: false,
      },

      togglePopup: {
        type: Function,
        default: () => {},
      },

      options: {
        type: Array,
        default: () => [],
      },

      selected: {
        type: Object,
        default: null,
      },
    },

    data() {
      return {
        tonal,
        selectedValue: null,
      }
    },

    mounted() {
      const { subCode, mainCode } = this.$route.query

      // 카테고리 홈 기획 개편 건으로 인한 처리
      // subCode가 존재하면 subCode를 사용, 그렇지 않으면 mainCode를 사용
      const code = subCode || mainCode
      const foundItem = this.options.find((item) => item.value === code)

      if (foundItem) {
        this.selectedValue = foundItem.title
      } else {
        this.selectedValue = ''
      }
    },

    methods: {
      isSelected(option) {
        return option.title === this.selectedValue
      },

      onSelect(option, index) {
        if (option.value === this.$route.query.mainCode) {
          if (this.$route.name !== 'MainCategory') {
            this.$router.push({
              name: 'MainCategory',
              query: {
                mainCode: option.value,
              },
            })
          }

          this.onClose()

          return
        }

        this.selectedValue = option.title

        this.$emit('select', { option, index })

        this.onClose()
      },

      onClose() {
        this.$emit('close')
      },
    },
  }
</script>

<style scoped lang="scss">
  .popup-overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 136px 0;

    .popup-header {
      position: absolute;
      top: 36px;
      right: 16px;

      .close-btn {
        cursor: pointer;
      }
    }

    .popup-content {
      padding: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 24px;
      width: 100%;
      height: 100%;
      overflow-y: auto;

      li {
        font-weight: 400;
        font-size: 16px;
        line-height: 24px;

        user-select: none;
        cursor: pointer;

        &.selected {
          font-size: 20px;
          line-height: 28px;
        }
      }
    }
  }
</style>
